import { Action, ActionCreator, ActionReducer, ReducerTypes, createReducer } from '@ngrx/store';
import produce from 'immer';

function convertReducer<TState, TAction extends Action = Action>(reducer: ActionReducer<TState, TAction>): ActionReducer<TState, TAction> {
    return (state: TState | undefined, action: TAction) => {
        return produce(state, (draft: TState) => reducer(draft, action)) as TState;
    };
}

export function createImmutableReducer<TState, TAction extends Action = Action>(
    initialState: TState,
    ...ons: ReducerTypes<TState, ActionCreator[]>[]
): ActionReducer<TState, TAction> {
    const reducer = createReducer(initialState, ...ons);

    return convertReducer(reducer);
}

export function combineReducers<TState, TAction extends Action = Action>(
    initialState: TState,
    ...reducers: ActionReducer<TState, TAction>[]
): ActionReducer<TState, TAction> {
    return (state = initialState, action) => {
        let newState = state;
        for (const reducer of reducers) {
            newState = reducer(newState, action);
        }

        return newState;
    };
}
